import React, { useState } from 'react';
import './ExportModal.css';

const ExportModal = ({ onClose }) => {
    const [exportFormat, setExportFormat] = useState('pdf');
    const [includeMetrics, setIncludeMetrics] = useState(true);
    const [includeAdvocacyFunnel, setIncludeAdvocacyFunnel] = useState(true);
    const [includeCallOutcomes, setIncludeCallOutcomes] = useState(true);
    const [includeDistrictData, setIncludeDistrictData] = useState(true);
    const [includeHourlyData, setIncludeHourlyData] = useState(true);
    const [includeTables, setIncludeTables] = useState(true);
    const [exportInProgress, setExportInProgress] = useState(false);

    const handleExport = () => {
        setExportInProgress(true);
        
        // Simulate export process
        setTimeout(() => {
            setExportInProgress(false);
            onClose();
            // Show success notification (you can implement this separately)
            alert('Export completed successfully!');
        }, 2000);
    };

    return (
        <div className="modal-overlay">
            <div className="export-modal">
                <div className="modal-header">
                    <h2>Export Report</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                
                <div className="modal-content">
                    <div className="export-section">
                        <h3>Export Format</h3>
                        <div className="format-options">
                            <label className="format-option">
                                <input
                                    type="radio"
                                    name="format"
                                    value="pdf"
                                    checked={exportFormat === 'pdf'}
                                    onChange={() => setExportFormat('pdf')}
                                />
                                <span className="format-icon">📄</span>
                                PDF Document
                            </label>
                            
                            <label className="format-option">
                                <input
                                    type="radio"
                                    name="format"
                                    value="excel"
                                    checked={exportFormat === 'excel'}
                                    onChange={() => setExportFormat('excel')}
                                />
                                <span className="format-icon">📊</span>
                                Excel Spreadsheet
                            </label>
                            
                            <label className="format-option">
                                <input
                                    type="radio"
                                    name="format"
                                    value="csv"
                                    checked={exportFormat === 'csv'}
                                    onChange={() => setExportFormat('csv')}
                                />
                                <span className="format-icon">📋</span>
                                CSV File
                            </label>
                        </div>
                    </div>
                    
                    <div className="export-section">
                        <h3>Content to Include</h3>
                        <div className="content-options">
                            <label className="content-option">
                                <input
                                    type="checkbox"
                                    checked={includeMetrics}
                                    onChange={() => setIncludeMetrics(!includeMetrics)}
                                />
                                Key Metrics
                                <span className="option-desc">Patch Throughs, Supporting Position, AI Minutes, etc.</span>
                            </label>
                            
                            <label className="content-option">
                                <input
                                    type="checkbox"
                                    checked={includeAdvocacyFunnel}
                                    onChange={() => setIncludeAdvocacyFunnel(!includeAdvocacyFunnel)}
                                />
                                Advocacy Funnel
                                <span className="option-desc">Total Universe, Records Contacted, Completed Calls, etc.</span>
                            </label>
                            
                            <label className="content-option">
                                <input
                                    type="checkbox"
                                    checked={includeCallOutcomes}
                                    onChange={() => setIncludeCallOutcomes(!includeCallOutcomes)}
                                />
                                Call Outcomes Distribution
                                <span className="option-desc">Patched, Disagreed, Undecided, etc.</span>
                            </label>
                            
                            <label className="content-option">
                                <input
                                    type="checkbox"
                                    checked={includeDistrictData}
                                    onChange={() => setIncludeDistrictData(!includeDistrictData)}
                                />
                                District Performance Data
                                <span className="option-desc">Support rates, Patch-through rates by district</span>
                            </label>
                            
                            <label className="content-option">
                                <input
                                    type="checkbox"
                                    checked={includeHourlyData}
                                    onChange={() => setIncludeHourlyData(!includeHourlyData)}
                                />
                                Hourly Call Analysis
                                <span className="option-desc">Patch-through volume and support rate by hour</span>
                            </label>
                            
                            <label className="content-option">
                                <input
                                    type="checkbox"
                                    checked={includeTables}
                                    onChange={() => setIncludeTables(!includeTables)}
                                />
                                Detailed Data Tables
                                <span className="option-desc">Full data tables with all metrics</span>
                            </label>
                        </div>
                    </div>
                    
                    <div className="export-section">
                        <h3>Time Range</h3>
                        <div className="timerange-display">
                            <span className="timerange-icon">📅</span>
                            <span>Last 30 Days (applies to all exported data)</span>
                        </div>
                    </div>
                </div>
                
                <div className="modal-footer">
                    <button className="cancel-btn" onClick={onClose} disabled={exportInProgress}>
                        Cancel
                    </button>
                    <button 
                        className="export-confirm-btn" 
                        onClick={handleExport}
                        disabled={exportInProgress}
                    >
                        {exportInProgress ? 'Exporting...' : 'Export Report'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal; 